import buildGraphEndpoint from './buildGraphEndpoint';
import buildResultEndpoint from './buildResultEndpoint';

export type AnalyticsDataRequest = {
  url: string;
  method: 'GET' | 'POST';
  body: Record<string, string | number> | null;
};

type BuildAnalyticsDataRequestParams = {
  view: string;
  source: string;
  tab: string;
  searchItems: Array<{ id: string }>;
  pageNum: number;
  pageSize: number;
  orderByParam: string;
  order?: string;
  summaryMatchEncodedParams?: Record<string, string> | null;
};

export function buildAnalyticsDataRequest({
  view,
  source,
  tab,
  searchItems,
  pageNum,
  pageSize,
  orderByParam,
  order = 'desc',
  summaryMatchEncodedParams = null,
}: BuildAnalyticsDataRequestParams): AnalyticsDataRequest {
  if (summaryMatchEncodedParams && Object.keys(summaryMatchEncodedParams).length > 0) {
    const built = buildResultEndpoint({
      view,
      source,
      tab,
      searchItems,
      isEvidence: false,
      isMapping: false,
      mappingContent: null,
      pageNum,
      pageSize,
      orderByParam,
      order,
      defaultFilterValue: [],
      sourceWeights: [],
      summaryMatchParams: null,
      summaryMatchEncodedParams,
    });

    if (built?.method === 'POST') {
      return {
        url: built.url,
        method: 'POST',
        body: built.body as Record<string, string | number>,
      };
    }
  }

  return {
    url: buildGraphEndpoint(view, source, tab, searchItems, pageNum, pageSize, orderByParam, order),
    method: 'GET',
    body: null,
  };
}
